import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const homeModel = class {

    async Get() {
        return await axiosInstance.get(Baseurl +"/users/get/home");
    }
    async GetBanner() {
        return await axiosInstance.get(Baseurl +"/users/get/home?banner_type=web");
    }
}

export default new homeModel();